/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    AccountDeletionRequestResultDTO,
    ConsentsResponseDTO,
    DataProtectionRequestResultDTO,
    DataProtectionUpdateRequestResultDTO,
    GetRequestDataProtectionConsentValuesParams,
    GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    GetRequestDataProtectionRequestDataAccessParams,
    HTTPValidationErrorDTO,
    PostRequestDataProtectionConsentValuesBodies,
    PostRequestDataProtectionConsentValuesParams,
    PostRequestDataProtectionRequestAccountDeletionParams,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Update consent values stored in the local consent system

 * @summary Update Data Protection Consents
 */
export const postRequestDataProtectionConsentValues = (
    postRequestDataProtectionConsentValuesBodies: BodyType<PostRequestDataProtectionConsentValuesBodies>,
    params: PostRequestDataProtectionConsentValuesParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DataProtectionUpdateRequestResultDTO>(
        {
            url: `/data_protection/consent_values`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestDataProtectionConsentValuesBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestDataProtectionConsentValuesMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>,
        TError,
        {
            data: BodyType<PostRequestDataProtectionConsentValuesBodies>
            params: PostRequestDataProtectionConsentValuesParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>,
    TError,
    {
        data: BodyType<PostRequestDataProtectionConsentValuesBodies>
        params: PostRequestDataProtectionConsentValuesParams
    },
    TContext
> => {
    const mutationKey = ['postRequestDataProtectionConsentValues']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>,
        {
            data: BodyType<PostRequestDataProtectionConsentValuesBodies>
            params: PostRequestDataProtectionConsentValuesParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestDataProtectionConsentValues(
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestDataProtectionConsentValuesMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>
>
export type PostRequestDataProtectionConsentValuesMutationBody =
    BodyType<PostRequestDataProtectionConsentValuesBodies>
export type PostRequestDataProtectionConsentValuesMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Update Data Protection Consents
 */
export const usePostRequestDataProtectionConsentValues = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>,
            TError,
            {
                data: BodyType<PostRequestDataProtectionConsentValuesBodies>
                params: PostRequestDataProtectionConsentValuesParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestDataProtectionConsentValues>>,
    TError,
    {
        data: BodyType<PostRequestDataProtectionConsentValuesBodies>
        params: PostRequestDataProtectionConsentValuesParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestDataProtectionConsentValuesMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Consent values stored in the local consent system

 * @summary Get Data Protection Consents
 */
export const getRequestDataProtectionConsentValues = (
    params: GetRequestDataProtectionConsentValuesParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<ConsentsResponseDTO>(
        {
            url: `/data_protection/consent_values`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestDataProtectionConsentValuesQueryKey = (
    params?: GetRequestDataProtectionConsentValuesParams,
) => {
    return [
        `/data_protection/consent_values`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestDataProtectionConsentValuesQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionConsentValuesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionConsentValues>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestDataProtectionConsentValuesQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>
    > = ({ signal }) =>
        getRequestDataProtectionConsentValues(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestDataProtectionConsentValuesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>
>
export type GetRequestDataProtectionConsentValuesQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestDataProtectionConsentValues<
    TData = Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionConsentValuesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionConsentValues>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestDataProtectionConsentValues>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestDataProtectionConsentValues>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionConsentValues<
    TData = Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionConsentValuesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionConsentValues>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestDataProtectionConsentValues>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestDataProtectionConsentValues>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionConsentValues<
    TData = Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionConsentValuesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionConsentValues>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Data Protection Consents
 */

export function useGetRequestDataProtectionConsentValues<
    TData = Awaited<ReturnType<typeof getRequestDataProtectionConsentValues>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionConsentValuesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionConsentValues>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestDataProtectionConsentValuesQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * An endpoint returning all the metadata stored in connection with the user

 * @summary Request Data Access
 */
export const getRequestDataProtectionRequestDataAccess = (
    params: GetRequestDataProtectionRequestDataAccessParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/data_protection/request_data_access`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestDataProtectionRequestDataAccessQueryKey = (
    params?: GetRequestDataProtectionRequestDataAccessParams,
) => {
    return [
        `/data_protection/request_data_access`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestDataProtectionRequestDataAccessQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccess>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionRequestDataAccessParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionRequestDataAccess>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestDataProtectionRequestDataAccessQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestDataProtectionRequestDataAccess>>
    > = ({ signal }) =>
        getRequestDataProtectionRequestDataAccess(
            params,
            requestOptions,
            signal,
        )

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestDataProtectionRequestDataAccess>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestDataProtectionRequestDataAccessQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestDataProtectionRequestDataAccess>>
>
export type GetRequestDataProtectionRequestDataAccessQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestDataProtectionRequestDataAccess<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccess>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionRequestDataAccessParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionRequestDataAccess>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccess
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccess
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionRequestDataAccess<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccess>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionRequestDataAccessParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionRequestDataAccess>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccess
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccess
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionRequestDataAccess<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccess>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionRequestDataAccessParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionRequestDataAccess>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Request Data Access
 */

export function useGetRequestDataProtectionRequestDataAccess<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccess>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDataProtectionRequestDataAccessParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestDataProtectionRequestDataAccess>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestDataProtectionRequestDataAccessQueryOptions(
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This is an endpoint to check if we are able to ask for a data request

 * @summary Allow New Data Access Request
 */
export const getRequestDataProtectionRequestDataAccessAvailability = (
    params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DataProtectionRequestResultDTO>(
        {
            url: `/data_protection/request_data_access_availability`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestDataProtectionRequestDataAccessAvailabilityQueryKey =
    (params?: GetRequestDataProtectionRequestDataAccessAvailabilityParams) => {
        return [
            `/data_protection/request_data_access_availability`,
            ...(params ? [params] : []),
        ] as const
    }

export const getGetRequestDataProtectionRequestDataAccessAvailabilityQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestDataProtectionRequestDataAccessAvailability
            >
        >,
        TError = ErrorType<HTTPValidationErrorDTO | void>,
    >(
        params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccessAvailability
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestDataProtectionRequestDataAccessAvailabilityQueryKey(
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestDataProtectionRequestDataAccessAvailability
                >
            >
        > = ({ signal }) =>
            getRequestDataProtectionRequestDataAccessAvailability(
                params,
                requestOptions,
                signal,
            )

        return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestDataProtectionRequestDataAccessAvailability
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestDataProtectionRequestDataAccessAvailabilityQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestDataProtectionRequestDataAccessAvailability
            >
        >
    >
export type GetRequestDataProtectionRequestDataAccessAvailabilityQueryError =
    ErrorType<HTTPValidationErrorDTO | void>

export function useGetRequestDataProtectionRequestDataAccessAvailability<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccessAvailability>
    >,
    TError = ErrorType<HTTPValidationErrorDTO | void>,
>(
    params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestDataProtectionRequestDataAccessAvailability
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccessAvailability
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccessAvailability
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionRequestDataAccessAvailability<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccessAvailability>
    >,
    TError = ErrorType<HTTPValidationErrorDTO | void>,
>(
    params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestDataProtectionRequestDataAccessAvailability
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccessAvailability
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestDataProtectionRequestDataAccessAvailability
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestDataProtectionRequestDataAccessAvailability<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccessAvailability>
    >,
    TError = ErrorType<HTTPValidationErrorDTO | void>,
>(
    params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestDataProtectionRequestDataAccessAvailability
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Allow New Data Access Request
 */

export function useGetRequestDataProtectionRequestDataAccessAvailability<
    TData = Awaited<
        ReturnType<typeof getRequestDataProtectionRequestDataAccessAvailability>
    >,
    TError = ErrorType<HTTPValidationErrorDTO | void>,
>(
    params: GetRequestDataProtectionRequestDataAccessAvailabilityParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestDataProtectionRequestDataAccessAvailability
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestDataProtectionRequestDataAccessAvailabilityQueryOptions(
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Request account deletion. The user will be locked out of Capture and all auths will be disabled.
The actual user account deletion will be an async process.

 * @summary Request Account Deletion
 */
export const postRequestDataProtectionRequestAccountDeletion = (
    params: PostRequestDataProtectionRequestAccountDeletionParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AccountDeletionRequestResultDTO>(
        {
            url: `/data_protection/request_account_deletion`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestDataProtectionRequestAccountDeletionMutationOptions =
    <
        TError = ErrorType<HTTPValidationErrorDTO | void>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestDataProtectionRequestAccountDeletion
                >
            >,
            TError,
            { params: PostRequestDataProtectionRequestAccountDeletionParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestDataProtectionRequestAccountDeletion>
        >,
        TError,
        { params: PostRequestDataProtectionRequestAccountDeletionParams },
        TContext
    > => {
        const mutationKey = ['postRequestDataProtectionRequestAccountDeletion']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestDataProtectionRequestAccountDeletion
                >
            >,
            { params: PostRequestDataProtectionRequestAccountDeletionParams }
        > = (props) => {
            const { params } = props ?? {}

            return postRequestDataProtectionRequestAccountDeletion(
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestDataProtectionRequestAccountDeletionMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestDataProtectionRequestAccountDeletion>
        >
    >

export type PostRequestDataProtectionRequestAccountDeletionMutationError =
    ErrorType<HTTPValidationErrorDTO | void>

/**
 * @summary Request Account Deletion
 */
export const usePostRequestDataProtectionRequestAccountDeletion = <
    TError = ErrorType<HTTPValidationErrorDTO | void>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestDataProtectionRequestAccountDeletion
                >
            >,
            TError,
            { params: PostRequestDataProtectionRequestAccountDeletionParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestDataProtectionRequestAccountDeletion>>,
    TError,
    { params: PostRequestDataProtectionRequestAccountDeletionParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestDataProtectionRequestAccountDeletionMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
